import React from 'react';
import { InboxIcon } from 'lucide-react';
export interface Column<T> {
  header: string;
  render: (row: T) => React.ReactNode;
  align?: 'left' | 'right';
}
interface DataTableProps<T> {
  rows: T[];
  columns: Column<T>[];
  rowKey: (row: T) => string;
  emptyTitle: string;
  emptyText: string;
}
export function DataTable<T>({
  rows,
  columns,
  rowKey,
  emptyTitle,
  emptyText
}: DataTableProps<T>) {
  if (rows.length === 0) {
    return <div className="flex flex-col items-center rounded border border-dashed border-line-strong px-6 py-12 text-center" data-id="element-133" data-mp="17mwy9hm5nfcz">
        <InboxIcon className="h-8 w-8 text-line-strong" aria-hidden="true" data-id="element-134" data-mp="ylfnmerio5vo" />
        <p className="mt-2 text-sm font-semibold text-ink" data-id="element-135" data-mp="yl5sydvj1ajn">{emptyTitle}</p>
        <p className="mt-1 max-w-sm text-sm text-muted" data-id="element-136" data-mp="12lpqvjnxci6u">{emptyText}</p>
      </div>;
  }
  return <div className="overflow-x-auto rounded border border-line" data-id="element-137" data-mp="3javbp1zcpghm">
      <table className="w-full min-w-[640px] border-collapse text-sm" data-id="element-138" data-mp="3ndrmw7mkaabj">
        <thead data-id="element-139" data-mp="3nax3mjfaavjp">
          <tr className="bg-canvas text-xs font-semibold text-muted" data-id="element-140" data-mp="mc5e8suudfu1">
            {columns.map(c => <th key={c.header} scope="col" className={`px-3 py-2 ${c.align === 'right' ? 'text-right' : 'text-left'}`} data-id="element-141" data-mp="hdu56kcdf9cv">
                {c.header}
              </th>)}
          </tr>
        </thead>
        <tbody data-id="element-142" data-mp="rb8k2finbq32">
          {rows.map(row => <tr key={rowKey(row)} className="border-t border-line hover:bg-[#fafafa]" data-id="element-143" data-mp="rdl20soem0g4">
              {columns.map(c => <td key={c.header} className={`px-3 py-2.5 text-ink ${c.align === 'right' ? 'text-right' : ''}`} data-id="element-144" data-mp="10cg69z7w10gs">
                  {c.render(row)}
                </td>)}
            </tr>)}
        </tbody>
      </table>
    </div>;
}